/**
 * 与 client-h5 对齐：导航高度 + 顶部安全区。
 * 旧 App（_appCode <= 60007 且无原生注入）保持 15.5vw。
 */
export const LEGACY_NAV_APP_CODE = 60007;
export const NAV_CONTENT_HEIGHT = '36px';
export const LEGACY_NAV_CONTENT_HEIGHT = '15.5vw';

function parsePx(value) {
  if (!value) return 0;
  const n = parseFloat(String(value).trim());
  return Number.isFinite(n) ? n : 0;
}

export function readSafeTopPx() {
  try {
    return parsePx(
      getComputedStyle(document.documentElement).getPropertyValue('--safe-area-top')
      || getComputedStyle(document.documentElement).getPropertyValue('--safe-top'),
    );
  } catch (e) {
    return 0;
  }
}

function resolveAppCode(explicit) {
  if (explicit != null && Number.isFinite(explicit)) return Number(explicit);
  const fromWin = Number(window._appCode);
  if (Number.isFinite(fromWin) && fromWin > 0) return fromWin;
  const fromStore = Number(localStorage.getItem('sscm_app_version') || 0);
  return Number.isFinite(fromStore) ? fromStore : 0;
}

export function shouldUseLegacyNav(appCode) {
  if (window.__NAV_METRICS_V2__ === true || window.__NAV_METRICS_V2__ === '1') {
    return false;
  }
  const isApp = !!(window.mobileRuntime && window.mobileRuntime.isApp) || !!window.isClient;
  if (!isApp) return false;
  const code = resolveAppCode(appCode);
  return code > 0 && code <= LEGACY_NAV_APP_CODE;
}

export function isNativeChrome() {
  if (window.__NAV_CHROME__ === 'native') return true;
  if (document.documentElement.getAttribute('data-chrome') === 'native') return true;
  try {
    const q = new URLSearchParams(location.search);
    if (q.get('chrome') === 'native') return true;
    const hash = location.hash || '';
    const qi = hash.indexOf('?');
    if (qi >= 0) {
      const hq = new URLSearchParams(hash.slice(qi + 1));
      if (hq.get('chrome') === 'native') return true;
    }
  } catch (e) {
    /* ignore */
  }
  return false;
}

export function setSafeTopCssPx(px) {
  if (!(px > 0)) return;
  const v = `${Math.round(px * 100) / 100}px`;
  const root = document.documentElement;
  root.style.setProperty('--safe-area-top', v);
  root.style.setProperty('--safe-top', v);
}

export function applyNavChromeMetrics(appCode) {
  const root = document.documentElement;
  const legacy = shouldUseLegacyNav(appCode);
  const native = isNativeChrome();

  if (legacy) {
    root.classList.add('nav-legacy');
    root.style.setProperty('--nav-content-height', LEGACY_NAV_CONTENT_HEIGHT);
    root.style.setProperty('--footer-height', LEGACY_NAV_CONTENT_HEIGHT);
    root.style.setProperty('--nav-safe-factor', native ? '0' : '1');
    if (native) {
      root.style.setProperty('--state-bar-height', '0px');
      root.style.setProperty('--safe-area-top', '0px');
      root.style.setProperty('--safe-top', '0px');
    }
    return;
  }

  root.classList.remove('nav-legacy');
  root.style.setProperty('--nav-content-height', NAV_CONTENT_HEIGHT);
  root.style.setProperty('--footer-height', NAV_CONTENT_HEIGHT);
  root.style.removeProperty('--state-bar-height');

  if (native) {
    root.setAttribute('data-chrome', 'native');
    root.style.setProperty('--nav-safe-factor', '0');
    root.style.setProperty('--safe-area-top', '0px');
    root.style.setProperty('--safe-top', '0px');
    root.style.setProperty('--state-bar-height', '0px');
    return;
  }

  root.style.setProperty('--nav-safe-factor', '1');
}
